import { FormErrors } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

export interface WorkConditionVersionItemsFormData {
  items: Record<string, string> // 'max_work_hours_year' -> '1000'
  types: Record<string, string> // 'max_work_hours_year' -> number
}

export const validateWorkConditionItems = (
  data: WorkConditionVersionItemsFormData
): FormErrors<WorkConditionVersionItemsFormData> => {
  const errors: FormErrors<WorkConditionVersionItemsFormData> = {}

  Object.keys(data.items).forEach((key) => {
    const value = data.items[key]
    const type = data.types[key]

    if (type === 'number') {
      validateNumber(key, value, errors)
    }

    if (type === 'string') {
      validateString(key, value, errors)
    }
  })

  return errors
}

const addError = (
  errors: FormErrors<WorkConditionVersionItemsFormData>,
  key: string,
  message: string
) => {
  if (!errors.items) errors.items = {}
  errors.items[key] = message
}

const validateNumber = (
  key: string,
  value: string | undefined,
  errors: FormErrors<WorkConditionVersionItemsFormData>
) => {
  const numberValue = Number(value)

  if (isNaN(numberValue) || !Number.isInteger(numberValue)) {
    addError(
      errors,
      key,
      i18n.t(
        'company_settings.general.employment_data.work_conditions.common.validations.must_be_a_number'
      )
    )
  } else if (numberValue <= 0) {
    //if (!errors.items) errors.items = {}
    addError(
      errors,
      key,
      i18n.t(
        'company_settings.general.employment_data.work_conditions.common.validations.must_be_positive'
      )
    )
  } else if (numberValue > 9999) {
    addError(
      errors,
      key,
      i18n.t('company_settings.general.employment_data.work_conditions.common.validations.too_high')
    )
  }
}

const validateString = (
  key: string,
  value: string | undefined,
  errors: FormErrors<WorkConditionVersionItemsFormData>
) => {
  if (value === undefined || value === null || value === '') {
    addError(
      errors,
      key,
      i18n.t(
        'company_settings.general.employment_data.work_conditions.common.validations.must_not_be_empty'
      )
    )
  }
}
